var _path, _path2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGasIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1177 10H14.353C14.8728 10 15.2941 10.4214 15.2941 10.9412V14.2353C15.2941 14.7551 15.7155 15.1765 16.2353 15.1765H16.7059C17.2257 15.1765 17.6471 14.7551 17.6471 14.2353V8.97809C17.6471 8.72848 17.5479 8.48908 17.3714 8.31258L15.2941 6.2353",
    stroke: "#606060",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.35291 7.88236V18H13.8823V7.88236C13.8823 6.84277 13.0396 6.00001 12 6.00001H8.23526C7.19566 6.00001 6.35291 6.84277 6.35291 7.88236Z",
    stroke: "#606060"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.76477,
    y: 8.11765,
    width: 4.70588,
    height: 3.76471,
    rx: 0.470588,
    stroke: "#606060"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGasIcon);
export default __webpack_public_path__ + "static/media/gas-icon.fd405405c9e7d3eacc030fa9e3da72db.svg";
export { ForwardRef as ReactComponent };